import React from "react";
import SubtitleAndDescription from "../Common/SubtitleAndDescription";
import SquareGuidePromo from "./SquareGuidePromo";

const PageSectionCrossLinks = ({ description, guideData, classType, specType }) => {
  return (
    <div className="page-section-cross-links-container">
      <SubtitleAndDescription
        className="cross-links-subtitle"
        description={description}
        subtitle={
          <img src="https://static.bigbrain.gg/wow/assets/uggxicyveins.svg" alt="U.GG x Icy Veins" style={{ height: "20px" }} />
        }
      />
      <div className="square-guide-promos-container">
        {guideData.map((guide, index) => (
          <SquareGuidePromo
            classType={classType}
            guideDescription={guide.description}
            guideLink={guide.link}
            guideTitle={guide.title}
            key={index}
            specType={specType}
          />
        ))}
      </div>
    </div>
  );
};

export default PageSectionCrossLinks;
